export const zuiKey = 'x-zui' as const
